import JobGridProgressContainer from "../../../components/job/grid/JobGridProgress";

const JobGridProgress = () => {
  return <JobGridProgressContainer />;
};

export default JobGridProgress;
